import rootReducer from './rootReducer'
import logger from 'redux-logger'
import { configureStore } from '@reduxjs/toolkit'

const localStorageKey = 'reduxStore'

const hadleLSData = () => {
	if (typeof window !== 'undefined') {
		const fromLS =  localStorage?.getItem(localStorageKey)
		return fromLS ? JSON.parse(fromLS) : {}
	} else {
		return {}
	}
}

const store = configureStore({
	reducer: rootReducer,
	middleware: getDefaultMiddleware => getDefaultMiddleware().concat(logger),
	preloadedState: hadleLSData(),
})

store.subscribe(() => {
	const {userReducer = {}, orderReducer = {}} = store.getState()
	localStorage?.setItem(localStorageKey, JSON.stringify({userReducer, orderReducer}))
})

export default store
